module.exports = __webpack_public_path__ + "img/vertical_3_2_3009.932f6826.png";